import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import endpoints from "../config/endpoints";
import { apiGet, apiPost } from "../utils/api_service";
const initialState = {
  stockTransfer: [],
  //   stockTransferDriver: [],
};
let URL = endpoints.stockTransferInOutHeader;
const stockTransferSlice = createSlice({
  name: "stockTransfer",
  initialState,
  reducers: {
    stockTransferSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        stockTransfer: row,
      };
    },
    // stockTransferNewSuccess: (state = cloneDeep(initialState), action) => {
    //   const { row } = action.payload;
    //   return {
    //     ...state,
    //     stockTransferDriver: row,
    //   };
    // },

    resetState: (state = cloneDeep(initialState), action) => {
      return {
        ...state,
        ...initialState,
      };
    },
  },
});

export const { stockTransferSuccess, resetState } = stockTransferSlice.actions;

export default stockTransferSlice.reducer;

export const getStockTransferInOutHeader =
  ({ stockStakeHolderId, fromDate, toDate }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            URL +
            "/by-stock-stake-holder-and-dates?stockStakeHolderId=" +
            stockStakeHolderId +
            "&fromDate=" +
            fromDate +
            "&toDate=" +
            toDate,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((stockTranferObj, index) => {
              let stockTransferData = {
                index: index + 1,
                id: stockTranferObj.id === null ? "" : stockTranferObj.id,
                date: stockTranferObj.date === null ? "" : stockTranferObj.date,
                transferNo:
                  stockTranferObj.transferNo === null
                    ? ""
                    : stockTranferObj.transferNo,
                stockStakeHolderName:
                  stockTranferObj.stockStakeHolderName === null
                    ? ""
                    : stockTranferObj.stockStakeHolderName,
                fromTransferHolderName:
                  stockTranferObj.fromTransferHolderName === null
                    ? ""
                    : stockTranferObj.fromTransferHolderName,
                toTransferHolderName:
                  stockTranferObj.toTransferHolderName === null
                    ? ""
                    : stockTranferObj.toTransferHolderName,
                fromTransferVehicleName:
                  stockTranferObj.fromTransferVehicleName === null
                    ? ""
                    : stockTranferObj.fromTransferVehicleName,
                toTransferVehicleName:
                  stockTranferObj.toTransferVehicleName === null
                    ? ""
                    : stockTranferObj.toTransferVehicleName,
                transaction:
                  stockTranferObj.flag === null ? "" : stockTranferObj.flag == 0 ? "Out" : "In",
                statusForTable:
                  stockTranferObj.status === null ? "" :
                    stockTranferObj.status == 0 ? "Pending" :
                      stockTranferObj.status == 1 ? "Approved" :
                        stockTranferObj.status == 2 ? "Cancelled" : "Settled",
                status:
                  stockTranferObj.status === null ? "" : stockTranferObj.status,
                approvedStatus:
                  stockTranferObj.status !== null && stockTranferObj.flag !== null ?
                    stockTranferObj.status == 0 && stockTranferObj.flag == 1 ? 1 : 0 : "",
                flag:
                  stockTranferObj.flag === null ? "" : stockTranferObj.flag,
                isShowEditDeleteFlag: 
                  stockTranferObj.isSelf !== null && stockTranferObj.status !== null ?  
                  stockTranferObj.isSelf == 1 && stockTranferObj.status == 0 ? 1 : 0 :"" ,

              };
              return stockTransferData;
            });
            dispatch(stockTransferSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getStockTransferInOutHeaderByDriver =
  ({ driverId, stockStakeHolderId, fromDate, toDate }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            URL +
            "/by-driver-stock-stake-holder-and-dates?driverId=" +
            driverId +
            "&stockStakeHolderId=" +
            stockStakeHolderId +
            "&fromDate=" +
            fromDate +
            "&toDate=" +
            toDate,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((stockTranferObjNew, index) => {
              let stockTransferDataNew = {
                index: index + 1,
                id: stockTranferObjNew.id === null ? "" : stockTranferObjNew.id,
                date: stockTranferObjNew.date === null ? "" : stockTranferObjNew.date,
                transferNo:
                  stockTranferObjNew.transferNo === null
                    ? ""
                    : stockTranferObjNew.transferNo,
                stockStakeHolderName:
                  stockTranferObjNew.stockStakeHolderName === null
                    ? ""
                    : stockTranferObjNew.stockStakeHolderName,
                fromTransferHolderName:
                  stockTranferObjNew.fromTransferHolderName === null
                    ? ""
                    : stockTranferObjNew.fromTransferHolderName,
                toTransferHolderName:
                  stockTranferObjNew.toTransferHolderName === null
                    ? ""
                    : stockTranferObjNew.toTransferHolderName,
                fromTransferVehicleName:
                  stockTranferObjNew.fromTransferVehicleName === null
                    ? ""
                    : stockTranferObjNew.fromTransferVehicleName,
                toTransferVehicleName:
                  stockTranferObjNew.toTransferVehicleName === null
                    ? ""
                    : stockTranferObjNew.toTransferVehicleName,

                type:
                  stockTranferObjNew.type === null ? "" : stockTranferObjNew.type,
                stockStakeHolderId:
                  stockTranferObjNew.stockStakeHolderId === null
                    ? ""
                    : stockTranferObjNew.stockStakeHolderId,
                fromTransferHolderId:
                  stockTranferObjNew.fromTransferHolderId === null
                    ? ""
                    : stockTranferObjNew.fromTransferHolderId,
                toTransferHolderId:
                  stockTranferObjNew.toTransferHolderId === null
                    ? ""
                    : stockTranferObjNew.toTransferHolderId,
                fromTransferVehicleId:
                  stockTranferObjNew.fromTransferVehicleId === null
                    ? ""
                    : stockTranferObjNew.fromTransferVehicleId,
                toTransferVehicleId:
                  stockTranferObjNew.toTransferVehicleId === null
                    ? ""
                    : stockTranferObjNew.toTransferVehicleId,
                date:
                  stockTranferObjNew.date === null ? "" : stockTranferObjNew.date,
                status:
                  stockTranferObjNew.status === null
                    ? ""
                    : stockTranferObjNew.status,
                transaction:
                  stockTranferObjNew.flag === null ? "" : stockTranferObjNew.flag == 0 ? "Out" : "In",
                statusForTable:
                  stockTranferObjNew.status === null ? "" :
                    stockTranferObjNew.status == 0 ? "Pending" :
                      stockTranferObjNew.status == 1 ? "Approved" :
                        stockTranferObjNew.status == 2 ? "Cancelled" : "Settled",
                approvedStatus:
                  stockTranferObjNew.status !== null && stockTranferObjNew.flag !== null ?
                    stockTranferObjNew.status == 0 && stockTranferObjNew.flag == 1 ? 1 : 0 : "",
                insertedUserId:
                  stockTranferObjNew.insertedUserId === null
                    ? ""
                    : stockTranferObjNew.insertedUserId,
                insertedDateTime:
                  stockTranferObjNew.insertedDateTime === null
                    ? ""
                    : stockTranferObjNew.insertedDateTime,

                fromVehicleNo:
                  stockTranferObjNew.fromVehicleNo === null
                    ? ""
                    : stockTranferObjNew.fromVehicleNo,
                fromDriverNumber:
                  stockTranferObjNew.fromDriverNumber === null
                    ? ""
                    : stockTranferObjNew.fromDriverNumber,
                toVehicleNo:
                  stockTranferObjNew.toVehicleNo === null
                    ? ""
                    : stockTranferObjNew.toVehicleNo,
                toDriverNumber:
                  stockTranferObjNew.toDriverNumber === null
                    ? ""
                    : stockTranferObjNew.toDriverNumber,
                flag:
                  stockTranferObjNew.flag === null ? "" : stockTranferObjNew.flag,
                  

              };
              return stockTransferDataNew;
            });
            dispatch(stockTransferSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };
